import { BaseEntity, DefaultResponseWithData } from "./system";

export interface IAllLocationsResponse extends DefaultResponseWithData<ILocation[]> { }
export interface IWarehouseLocationsResponse extends DefaultResponseWithData<IWarehouseLocation[]> { }
export interface ILocationVehicleCountsResponse extends DefaultResponseWithData<ILocationVehicleCount[]> { }
export interface ILocationVehicleCountResponse extends DefaultResponseWithData<ILocationVehicleCount> { }

export enum LocationType {
  Yard = 0,
  Racking = 1
}

// In case we need a Point field:
// export interface Point {
//   x: number;
//   y: number;
// }

export interface ILocation extends BaseEntity {
  name: string;
  type: LocationType;
  capacity?: number | null;
  locationGroupId?: string | null;
  longitude?: number;
  latitude?: number;
  // point?: Point;
}

export interface ILocationVehicleCount {
  locationId: string;
  vehicleCount: number;
}


export interface IWarehouseLocation extends BaseEntity {
  displayName: string;
  capacity: number;
  // dto specific
  occupied?: number;
  isExcluded?: boolean;
}

export interface IWarehouseLocationImportRequest {
  names: string;
  capacity: number;
  previewOnly: boolean;
  // Supported by the API but not offered in the import modal - excluding a location hides its parts
  // from listings and stats, which is not something you want on a batch of brand new shelving.
  isExcluded?: boolean;
}

export interface IWarehouseLocationImportOutcome {
  name: string;
  reason: string;
  message?: string;
}

export interface IWarehouseLocationImportResult {
  previewOnly: boolean;
  capacity: number;
  toCreate: IWarehouseLocationImportOutcome[];
  alreadyExists: IWarehouseLocationImportOutcome[];
  repeatedInPaste: IWarehouseLocationImportOutcome[];
  invalid: IWarehouseLocationImportOutcome[];
}

export interface IWarehouseLocationImportResponse extends DefaultResponseWithData<IWarehouseLocationImportResult> { }
